export default {
  formSteps: {
    contact: 'Contact Information',
    travelDetails: 'Travel Details',
    traveler: 'Traveler Information',
    travelCosts: 'Travel Costs'
  }
}
